import { onlyNumbers } from './onlyNumbers';

const cpf = function (value) {
  const data = onlyNumbers(value);
  if (!data || data.length < 11) {
    return '';
  }
  return `${data.slice(0, 3)}.${data.slice(3, 6)}.${data.slice(6, 9)}-${data.slice(9, 11)}`;
};

export { cpf };
